var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        { 'nav-pc': _vm.innerWidth > 425 },
        { 'nav-mobile': _vm.innerWidth <= 425 },
        'nav',
    ]},[(_vm.innerWidth > 425)?_c('CustomPcNav',{attrs:{"navList":_vm.navList,"activeNum":_vm.activeNum},on:{"update:activeNum":function($event){_vm.activeNum=$event},"update:active-num":function($event){_vm.activeNum=$event}}}):_c('CustomMobileNav',{attrs:{"navList":_vm.navList,"activeNum":_vm.activeNum},on:{"update:activeNum":function($event){_vm.activeNum=$event},"update:active-num":function($event){_vm.activeNum=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }